module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['join-us', _vm.sub_class]
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "aligncenter",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aligncenter"
  }, [(_vm.video_url) ? _c('a', {
    staticClass: "btn default",
    attrs: {
      "id": "show-modal"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13px",
      "height": "14px",
      "viewBox": "0 0 13 14",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "latest-deck",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "btn-svg",
    attrs: {
      "id": "3-offer",
      "transform": "translate(-827.000000, -1427.000000)",
      "fill": "#FFFFFF"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Path-2",
      "points": "827 1427 827 1441.03125 839.1875 1434.03125"
    }
  })])])]), _vm._v("\n                    " + _vm._s(_vm.button_video_text) + "\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "videoWrapper"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.video_url,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-824182fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlockJoinUs.vue
// module id = 352
// module chunks = 0